import { render, staticRenderFns } from "./registerStep3.vue?vue&type=template&id=97987f0e&scoped=true"
import script from "./registerStep3.vue?vue&type=script&lang=js"
export * from "./registerStep3.vue?vue&type=script&lang=js"
import style0 from "./registerStep3.vue?vue&type=style&index=0&id=97987f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97987f0e",
  null
  
)

export default component.exports